export default {
  // 状态枚举
  StateEnum: {
    /// <summary>
    /// 删除
    /// </summary>
    Delete: -1,
    /// <summary>
    /// 禁用
    /// </summary>
    Disable: 0,
    /// <summary>
    /// 启用
    /// </summary>
    Enable: 1
  },
  /// <summary>
  /// 在线状态
  /// </summary>
  DeviceActiveEnum: {
    /// <summary>
    /// 离线
    /// </summary>
    Offline: 0,
    /// <summary>
    /// 在线
    /// </summary>
    Online: 1
  },
  /// <summary>
  /// 运行状态
  /// OEE_state
  /// </summary>
  DeviceStateEnum: {
    /// <summary>
    /// 关机
    /// </summary>
    Shutdown: 0,
    /// <summary>
    /// 运行
    /// </summary>
    Running: 1,
    /// <summary>
    /// 待机
    /// </summary>
    Standby: 2,
    /// <summary>
    /// 故障
    /// </summary>
    Fault: 3
  },
  /// <summary>
  /// 检查状态
  /// </summary>
  InspectionStateEnum: {
    /// <summary>
    /// 删除
    /// </summary>
    delete: -1,
    /// <summary>
    /// 任务下发
    /// </summary>
    start: 0,
    /// <summary>
    /// 检查中
    /// </summary>
    inspection: 1,
    /// <summary>
    /// 待审核
    /// </summary>
    audit: 2,
    /// <summary>
    /// 审核通过
    /// </summary>
    approve: 3,
    /// <summary>
    /// 未通过(重新检查)
    /// </summary>
    fail: 4,
    /// <summary>
    /// 完成
    /// </summary>
    finish: 8,
    /// <summary>
    /// 关闭
    /// </summary>
    close: 9
  },
  InspectionStateCnEnum: {
    '-1': '删除',
    0: '任务下发',
    1: '检查中',
    2: '待审核',
    3: '审核通过',
    4: '未通过(重新检查)',
    8: '完成',
    9: '关闭'
  }
};
